export default "__VITE_ASSET__OecZbX97__"